import React from 'react';
import PropTypes from 'prop-types';

import Headband from './headband';
import Header from './header';
import HeadBanner from './head-banner';
import CookieBannerCookieHub from './cookies';
import Footer from './footer';

import './layout.css';

const activateDateInput = () => {
  if (typeof $ !== 'undefined') {
    setTimeout(() => {
      function getDate(element) {
        const dateFormat = 'dd/mm/yy';
        let date;
        try {
          date = $.datepicker.parseDate(dateFormat, element.value);
        } catch (error) {
          date = null;
        }
        return date;
      }

      const datePickerSettings = {
        ...$.datepicker.regional.fr,
        defaultDate: '+1w',
        minDate: +0,
        changeMonth: true,
        numberOfMonths: 3,
      };

      const from = $('#snipcart_custom_Date-denlevement-de-la-marchandise')
        .datepicker(datePickerSettings)
        .on('change', function validateFrom() {
          to.datepicker('option', 'minDate', getDate(this));
        });
      const to = $('#snipcart_custom_Date-de-retour-de-la-marchandise')
        .datepicker(datePickerSettings)
        .on('change', function validateTo() {
          from.datepicker('option', 'maxDate', getDate(this));
        });
    }, 300);
  }
};

class Layout extends React.Component {
  componentDidMount() {
    activateDateInput();
  }

  componentDidUpdate() {
    activateDateInput();
  }

  render() {
    const { children } = this.props;
    activateDateInput();
    return (
      <>
        {/* <Headband /> */}
        <Header />
        <HeadBanner />
        <CookieBannerCookieHub
          googleTrackingId={process.env.GATSBY_GOOGLE_ANALYTICS_TRACKING_ID}
          cookieHubId={process.env.GATSBY_COOKIE_HUB_ID}
        />
        <div>
          <main>{children}</main>
        </div>
        <Footer />
      </>
    );
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
